import { useQuery } from 'react-query';
import axiosInstance from '../../api/axiosInstance';

const useFetchData = (endpoit, params) => {
    const fetchData = async () => {
        try {
            const response = await axiosInstance('GET', endpoit, null, params, 'application/json', `${process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_PRODUCTION_URL : process.env.REACT_APP_API_DEVELOPMENT_URL}`);
            // const response = await axiosInstance('GET', endpoit, null, params, 'application/json', `${process.env.REACT_APP_API_PRODUCTION_URL}`);
            return response.data;
        } catch (err) {
            return null;
        }
    };
    return useQuery([endpoit], () => fetchData(), {
        refetchInterval: 30000,
        refetchOnWindowFocus: false,
        // select: (data) => data?.data,
        // enabled: enabled === false ? false : true
    });
};

export default useFetchData;